<script lang="ts">
	import CalibrationOverlayAnimation from "./CalibrationOverlay_Animation.svelte"
	import { ProgressBar } from "misc-ui"
	import { ErrorReportIcon } from "luxedo-comps"
	import { Responsive } from "responsive"
	import { Device } from "luxedo-data"
	import { CalibrationController } from "../CalibrationController.svelte"

	interface Props {
		device: Device
	}

	let { device }: Props = $props()

	let calProgress = $derived(CalibrationController.runs[device.id].progress)
	let { progress, message, didError, description } = $derived(calProgress)

	let isMobile = $derived(Responsive.isMobile)

	function cancelCalibration() {
		CalibrationController.cancel(device)
	}
</script>

<div class="calibration-top">
	{#if didError}
		<ErrorReportIcon />
	{:else}
		<CalibrationOverlayAnimation />
	{/if}

	<ProgressBar width={isMobile ? "calc(100% - 4rem)" : "calc(100% - 8rem)"} percentage={progress} />
</div>
<div class="calibration-bottom">
	<h3 class={didError ? "error" : ""}>{@html message ?? "Initializing..."}</h3>
	<p>
		{@html description ??
			`Calibration is the process of shining patterns from a projector in one location, and taking images from a camera in another location, then using mathematical analysis to map the images accurately to the projector.`}
	</p>
</div>

<div class="button-container">
	<button class="link-button" onclick={cancelCalibration}> Cancel </button>
</div>

<style>
	h3.error {
		color: var(--color-error);
	}

	.calibration-top :global(.error-report-icon) {
		height: 8rem;
	}

	.calibration-bottom :global(.warn) {
		color: var(--color-main);
	}

	p {
		min-height: 6rem;
	}
</style>
